import { render, staticRenderFns } from "./SimpleCurriculumn.vue?vue&type=template&id=177db4c4"
import script from "./SimpleCurriculumn.vue?vue&type=script&lang=js"
export * from "./SimpleCurriculumn.vue?vue&type=script&lang=js"
import style0 from "./SimpleCurriculumn.vue?vue&type=style&index=0&id=177db4c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports